import { Box, Button, Paper, Stack, useMediaQuery, useTheme } from '@mui/material';
import Tune from '@old/assets/svg/AdministratorPage/tune.svg';
import { useNavigate } from 'react-router';
import { PATH } from '@old/data/core/paths';
import { useGlobalStore } from '@old/global-store/use-store';
import i18n from '../../../libs/language';

export function WarantsPanel() {
  const navigate = useNavigate();
  const { country_id } = useGlobalStore();

  const theme = useTheme();
  const matchMD = useMediaQuery(theme.breakpoints.down('lg'));

  const configButtonStyles = {
    color: '#FFF',
    fontSize: 12,
    borderRadius: 100,
    textTransform: 'none',
  };

  return (
    <>
      <Paper
        sx={{
          borderRadius: 4,
          padding: 2,
          gridColumn: matchMD ? '' : '3/5',
          gridRow: matchMD ? '' : '0/1',
        }}
        elevation={0}
      >
        <Stack
          direction="row"
          style={{
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              fontWeight: '600',
              fontSize: 17,
              display: 'flex',
              flex: 1,
              justifyContent: { xs: 'center', lg: 'left' },
              alignItems: 'center',
            }}
          >
            {i18n.t('app.administrator.warrant_information')}
          </Box>
          <Stack
            direction="row"
            style={{
              display: 'flex',
              gap: 10,
              flexWrap: 'wrap',
            }}
          >
            <Stack
              direction="row"
              style={{
                display: 'flex',
                flex: 1,
                gap: 10,
                justifyContent: 'center',
              }}
            >
              <Button
                variant="contained"
                size="small"
                disableElevation
                startIcon={<img src={Tune} alt="add" />}
                sx={configButtonStyles}
                onClick={() => navigate(`${PATH.WARRANTS}`)}
                disabled={country_id !== 1}
              >
                {i18n.t('app.administrator.warrant_button')}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
    </>
  );
}
